import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import series from './series/reducer';
import qualifications from './qualifications/reducer';
import components from './components/reducer';
import samplesManagement from './samplesManagement/reducer';
import notifications from './notification/reducer';
import replacementFiles from './replacementFiles/reducer';
import userData from './userData/reducer';
import consortiaManagement from './consortiaManagement/reducer';
import malpracticeReport from './malpracticeReports/reducer';
import sections from './sections/reducer';
import rmaSubmissionFailures from './rmaSubmissionFailures/reducer';

export const rootReducer = combineReducers({
  malpracticeReport,
  series,
  qualifications,
  components,
  notifications,
  replacementFiles,
  userData,
  consortiaManagement,
  sections,
  samplesManagement,
  rmaSubmissionFailures,
});

export type RootState = ReturnType<typeof rootReducer>;

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
